import { render, staticRenderFns } from "./b32.vue?vue&type=template&id=bcd422fe&scoped=true"
import script from "./b32.vue?vue&type=script&lang=js"
export * from "./b32.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd422fe",
  null
  
)

export default component.exports